import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { About } from 'src/app/interfaces/about';
import { Crew } from 'src/app/interfaces/crew';
import { AboutUsService } from 'src/app/services/about-us.service';
import { CrewService } from 'src/app/services/panels/crew.service';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {

  constructor(private getCrew:CrewService,private translate:TranslateService, private getAbout:AboutUsService) { }

  crews:Crew[]=[]
  
  about:About[]=[]
  
  name_ar:boolean = true
  name_en:boolean = false
  job_ar:boolean = true
  job_en:boolean = false
  about_ar:boolean =true
  about_en:boolean =false

  ngOnInit(): void {
    this.getCrew.getCrew().subscribe(data => this.crews = data)
    this.getAbout.getAboutDes().subscribe(data => this.about = data)

    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        this.name_ar = false
        this.name_en = true
        this.job_ar = false
        this.job_en = true
        this.about_ar = false
        this.about_en = true
      }
      else if(this.translate.currentLang == "ar") {
        this.name_ar = true
        this.name_en = false
        this.job_ar = true
        this.job_en = false
        this.about_ar = true
        this.about_en = false
      }
    })
  }

}
